// extracted by mini-css-extract-plugin
export default {"carousel":"DF-z"};